// extracted by mini-css-extract-plugin
module.exports = {"list":"list-module__list___UOhuN"};